import "./styles.css";

export default function App() {
  return (
    <div className="App">
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <div class="row">
        <div class="col col-sm-12 col-md-4 col-lg-4">
          <div class="card">
            <div class="card-body">
              <h6 class="card-price text-center">
                $0<span class="period">/month</span>
              </h6>
              <div className="text">
                <p>
                  <ion-icon name="checkmark-outline"></ion-icon>Single User
                </p>
                <p>
                  <ion-icon name="checkmark-outline"></ion-icon>5GB
                </p>
                <p>
                  <ion-icon name="checkmark-outline"></ion-icon>30 Days
                </p>
                <p>
                  <ion-icon name="checkmark-outline"></ion-icon>Prepaid
                </p>
                <p>
                  <ion-icon name="checkmark-outline"></ion-icon>Phone Support
                </p>
                <p>
                  <ion-icon name="checkmark-outline"></ion-icon>Special Offers
                </p>
                <button class="btn btn-primary">Claim</button>
              </div>
            </div>
          </div>
        </div>

        <div class="col col-sm-12 col-md-4 col-lg-4">
          <div class="card">
            <div class="card-body">
              <h6 class="card-price text-center">
                $0<span class="period">/month</span>
              </h6>
              <div className="text">
                <p>
                  {" "}
                  <ion-icon name="checkmark-outline"></ion-icon>Single User
                </p>
                <p>
                  {" "}
                  <ion-icon name="checkmark-outline"></ion-icon>5GB
                </p>
                <p>
                  {" "}
                  <ion-icon name="checkmark-outline"></ion-icon>30 Days
                </p>
                <p>
                  {" "}
                  <ion-icon name="checkmark-outline"></ion-icon>Prepaid
                </p>
                <p>
                  {" "}
                  <ion-icon name="checkmark-outline"></ion-icon>Phone Support
                </p>
                <p>
                  {" "}
                  <ion-icon name="checkmark-outline"></ion-icon>Special Offers
                </p>
                <button class="btn btn-primary">Claim</button>
              </div>
            </div>
          </div>
        </div>

        <div class="col col-sm-12 col-md-4 col-lg-4">
          <div class="card">
            <div class="card-body">
              <h6 class="card-price text-center">
                $0<span class="period">/month</span>
              </h6>
              <div className="text">
                <p>
                  {" "}
                  <ion-icon name="checkmark-outline"></ion-icon>Single User
                </p>
                <p>
                  {" "}
                  <ion-icon name="checkmark-outline"></ion-icon>5GB
                </p>
                <p>
                  {" "}
                  <ion-icon name="checkmark-outline"></ion-icon>30 Days
                </p>
                <p>
                  {" "}
                  <ion-icon name="checkmark-outline"></ion-icon>Prepaid
                </p>
                <p>
                  {" "}
                  <ion-icon name="checkmark-outline"></ion-icon>Phone Support
                </p>
                <p>
                  {" "}
                  <ion-icon name="checkmark-outline"></ion-icon>Special Offers
                </p>
                <button class="btn btn-primary">Claim</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
